
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/descargables/[slug]",
      function () {
        return require("private-next-pages/business/descargables/[slug].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/descargables/[slug]"])
      });
    }
  